/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const legalRepresentativeTranslations = {
  clientLegalRepresentative: {
    gender: {
      label: "Anrede Vertretung",
      values: {
        male: "Herr",
        female: "Frau",
      },
    },
    givenName: {
      label: "Vorname Vertretung",
    },
    familyName: {
      label: "Nachname Vertretung",
    },
    residenceAddress: {
      streetAddress: {
        label: "Straße und Hausnummer Vertretung",
      },
      postalCode: {
        label: "PLZ Vertretung",
      },
      addressLocality: {
        label: "Ort Vertretung",
      },
    },
  },
  secondClientLegalRepresentative: {
    gender: {
      label: "Anrede 2. Vertretung",
      values: {
        male: "Herr",
        female: "Frau",
      },
    },
    givenName: {
      label: "Vorname 2. Vertretung",
    },
    familyName: {
      label: "Nachname 2. Vertretung",
    },
    residenceAddress: {
      streetAddress: {
        label: "Straße und Hausnummer 2. Vertretung",
      },
      postalCode: {
        label: "PLZ 2. Vertretung",
      },
      addressLocality: {
        label: "Ort 2. Vertretung",
      },
    },
  },
};
